import { HoverableImagePreview, Panel } from "@kunduz/ui";
import { useRef } from "react";
import styles from "./learningMaterialItem.module.scss";

export const LearningMaterialItem = (props: Props) => {
  const { name, thumbnail, slug, description, preview, type } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const LinkComponent = props.linkAs ?? "a";

  const renderName = (name: string) =>
    type === "concept" ? <h2>{name}</h2> : <h3>{name}</h3>;

  return (
    <Panel className={styles["container"]}>
      <div ref={containerRef}>
        <HoverableImagePreview
          hoverSource={preview}
          staticSource={thumbnail}
          alt={name}
          className={styles["thumbnail"]}
          ref={containerRef}
        />
        <LinkComponent href={slug} className={styles["name"]}>
          {renderName(name)}
        </LinkComponent>
        <span className={styles["description"]}>{description}</span>
      </div>
    </Panel>
  );
};

interface Props {
  name: string;
  thumbnail: string;
  slug: string;
  description: string;
  preview: string;
  type: "module" | "concept";
  linkAs?: React.ElementType;
  lang: "tr" | "en";
}

export default LearningMaterialItem;
